"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationEvent = void 0;
exports.postNotification = postNotification;
var NotificationEvent = exports.NotificationEvent = {
  LOADER_LOADING: 'lead-gen.loader.loading',
  LOADER_ERROR: 'lead-gen.loader.error',
  MODAL_LOADED: 'lead-gen.modal.loaded',
  EMBED_LOADED: 'lead-gen.embed.loaded'
};
function postNotification(event) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  window.postMessage({
    event: event,
    payload: payload
  }, window.origin);
}